import * as React from 'react';
import convertToIContextualMenuItem from '../utils/convertToIContextualMenuItem';
import executeEntryPoint from '../utils/entryPointOperations/executeEntryPoint';
import { Addin } from 'owa-addins-store';
import { ControlIcons } from 'owa-addins-icons';
import { createAddinCommandSurfaceAction } from '../utils/contextMenuDataUtils';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { IconType } from 'office-ui-fabric-react/lib/Icon';
import { ImageFit, ImageLoadState } from 'office-ui-fabric-react/lib/Image';
import { ImageWithFallbackState } from './ImageWithFallback';
import { observer } from 'mobx-react';
import {
    canExecute,
    getAccessibilityText,
    getFirstCommand,
    needShowMenu,
} from '../utils/entryPointOperations/AddinChecker';

const styles = require('./AddinEntryButton.scss');

export interface AddinEntryButtonProps {
    hostItemIndex: string;
    addin: Addin;
}

@observer
export default class AddinEntryButton extends React.Component<
    AddinEntryButtonProps,
    ImageWithFallbackState
> {
    constructor(props: AddinEntryButtonProps) {
        super(props, {
            hasLoadFailed: false,
        });
        this.props = props;
        this.state = {
            hasLoadFailed: false,
        };
    }

    onLoadingStateChanged(loadState: ImageLoadState) {
        if (loadState == ImageLoadState.error) {
            this.setState({ hasLoadFailed: true });
        } else {
            this.setState({ hasLoadFailed: false });
        }
    }

    handleAddinButtonLeftClick = (e: any) => {
        e.stopPropagation();
        if (canExecute(this.props.addin)) {
            executeEntryPoint(this.props.hostItemIndex, getFirstCommand(this.props.addin));
        }
    };

    render() {
        const iconProps = {
            iconType: IconType.Image,
            imageProps: {
                src: this.props.addin.IconUrl,
                width: 16,
                height: 16,
                imageFit: ImageFit.contain,
                onLoadingStateChange: this.onLoadingStateChanged.bind(this),
            },
        };

        const fallbackIconProps = {
            iconType: IconType.Default,
            iconName: ControlIcons.Photo2,
        };

        const accessibilityText = getAccessibilityText(this.props.addin);
        const props = {
            className: styles.addinEntryButton,
            iconProps: this.state.hasLoadFailed ? fallbackIconProps : iconProps,
            title: accessibilityText,
            ariaLabel: accessibilityText,
        };

        if (canExecute(this.props.addin)) {
            return <IconButton onClick={this.handleAddinButtonLeftClick} {...props} />;
        }

        if (needShowMenu(this.props.addin)) {
            const surfaceActions = createAddinCommandSurfaceAction(this.props.addin);
            convertToIContextualMenuItem(this.props.hostItemIndex, surfaceActions);
            return (
                <IconButton
                    onMenuClick={this.handleAddinButtonLeftClick}
                    menuProps={surfaceActions.subMenuProps}
                    menuIconProps={null}
                    {...props}
                />
            );
        }

        return null;
    }
}
